import { focusEditor } from 'src/components/RichSlate';

import { getEditorTextContent } from './queries';
import {
  applyEditorTextChanges,
  replaceSlateEditorHtml,
  replaceSlateEditorText,
} from './transforms';

export const hasSlateContentChangeOperation = (operations) =>
  operations.some((op) => 'set_selection' !== op.type);

export const hasSlateSelectionOperation = (operations) =>
  operations.some((op) => 'set_selection' === op.type);

export const slateEditorHasContent = (editor) =>
  Array.isArray(editor?.children) && editor.children.length > 0;

export const createEditorInstanceImperativeHandle = (editor) => {
  return {
    applyTextChanges: (changes) => {
      applyEditorTextChanges(editor, changes);
    },
    getText: () => {
      return getEditorTextContent(editor);
    },
    replaceHtml: (newHtml) => {
      replaceSlateEditorHtml(editor, newHtml);
    },
    replaceText: (newText) => {
      replaceSlateEditorText(editor, newText);
    },
    focus: (atEnd = true) => {
      if (editor) {
        focusEditor({ editor, atEnd });
      }
    },
  };
};
